import { SearchDashboard, APTransactionRes } from '@/models/aptransactions.model'
import { VEClient } from '@/utils/axios'

export const postDashboard = async (data: SearchDashboard): Promise<APTransactionRes> => {
	const response = await VEClient.post(`/api/ap/dashboard`, data)
	return response.data
}